import React, { useEffect, useState } from "react";
import Pettycashdetailstab from "../pettycash/Pettcashdetailtab";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import {
  Modal,
  Box,
  Typography,
  Button,
  Autocomplete,
  TextField,
} from "@mui/material";
import DaterangePicker from "../../common/Daterangepicker";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import user from "../../assets/user.gif";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbsUpDownOutlinedIcon from "@mui/icons-material/ThumbsUpDownOutlined";
import formatDate from "../../common/Formatdate";
import toast from "react-hot-toast";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import { BlinkBlur } from "react-loading-indicators";
import formatDateAndTime from "../../common/formatDateAndTime";

function createData(
  id,
  customername,
  contactNo,
  emailAddress,
  city,
  duration,
  startdate,
  requiredvehicle
) {
  return {
    id,
    customername,
    contactNo,
    emailAddress,
    city,
    duration,
    startdate,
    requiredvehicle,
  };
}

const Customersubscriptiondashboard = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const pettyCashStatus = JSON.parse(
    localStorage.getItem("catalogValues")
  ).pettyCashStatus;
  const pettyCashStatusTypes = JSON.parse(
    localStorage.getItem("catalogValues")
  ).pettyCashStatus;
  delete pettyCashStatusTypes?.inverted;
  const pettyCashType = JSON.parse(
    localStorage.getItem("catalogValues")
  ).pettyCashTypes;
  const pettyCashCategoryType = JSON.parse(
    localStorage.getItem("catalogValues")
  ).pettyCashTypes;
  delete pettyCashCategoryType?.inverted;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const status = JSON.parse(localStorage.getItem("status"));
  const today = new Date();
  today.setHours(23, 59, 59, 999); // Clear time to midnight

  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  oneMonthAgo.setHours(0, 0, 0, 0);
  const [modalVisible, setModalVisible] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [stats, setStats] = useState(null);
  const [cities, setCities] = useState(null);
  const [hubs, setHubs] = useState(null);
  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });
  const [city, setCity] = useState("");
  const [hub, setHub] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [openTab, setOpenTab] = useState(false); // for total rows from backend

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20); // default 20 per page
  const [totalCount, setTotalCount] = useState(0); // for total rows from backend
  const [loading, setLoading] = useState(false);
  const [statusType, setStatusType] = useState(null);
  const [userList, setUserList] = useState([]);
  const [executiveId, setExecutiveId] = useState(null);
  const [vehicleId, setVehicleId] = useState(null);
  const [categoryId, setCategoryId] = useState(null);
  const [searchbypettycashid, setsearchbypettycashid] = useState(null);

  const handleViewClick = (row) => {
    setSelectedRow(row);
    setOpenTab(true);
  };

  const getTableData = async (
    customPage = page,
    customRowsPerPage = rowsPerPage
  ) => {
    setLoading(true);

    if (!formattedStartDate || !formattedEndDate)
      return toast.error("Date is mandatory to filter");

    try {
      const offset = customPage * customRowsPerPage;
      //   &startDate=${formattedStartDate}&endDate=${formattedEndDate}

      let query = `limit=${customRowsPerPage}&offset=${offset}`;

      if (city && hub) {
        query += `&cityId=${city}&hubId=${hub}`;
      }

      if (executiveId) {
        query += `&createdBy=${executiveId?.id}`;
      }

      if (statusType) {
        query += `&pettyCashStatus=${statusType}`;
      }

      if (vehicleId) {
        query += `&vehicleId=${vehicleId?.id}`;
      }

      if (categoryId) {
        query += `&cashFor=${categoryId}`;
      }

      if (searchbypettycashid) {
        query += `&pettyCashId=${searchbypettycashid}`;
      }

      const response = await fetch(
        `${apiUrl}/api/subscriptionquiries?${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        // setVehicleId(null);
        // setStatusType(null);
        // setExecutiveId(null);
        setTableData(data?.entities?.rows);
        setTotalCount(data?.entities?.count || 0);
        const value = data?.entities;
        delete value.rows;
        setStats(value);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching petty cash Table Data:", error);
    }
  };

  const getCityNames = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/cities/indexify`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data) {
        setCities(data);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  const handleCityChange = (event) => {
    const value = event.target.value;
    setCity(value);
    // Optional: add any additional logic here
    getHubNames(value);
  };

  const handleHubChange = (event) => {
    const value = event.target.value;
    setHub(value);
  };

  const handleStatusChange = (event) => {
    const value = event.target.value;
    setStatusType(value);
  };

  const handleCategoryChange = (event) => {
    const value = event.target.value;
    setCategoryId(value);
  };

  const getHubNames = async (value) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/hubs?limit=100&cityId=${value}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setHubs(data?.entities?.rows);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching hub Names:", error);
    }
  };

  const getUsersLimitDetails = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/users?limit=1000&isSystemUser=${1}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        const userData = data?.entities?.rows;
        let filterTheData = userData.map((item, index) => ({
          id: item?.id,
          name: item?.name,
          email: item?.email,
        }));
        setUserList(filterTheData);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error(
        "Error fetching user limits list in the fuel details tab:",
        error
      );
    }
  };

  useEffect(() => {
    // getTableData();
    getCityNames();
    getUsersLimitDetails();
  }, []);

  useEffect(() => {
    if (cities) {
      getTableData();
    }
  }, [cities]);

  const columns = [
    { id: "id", label: "Id", minWidth: 70, align: "center", },
    { id: "customername", label: "Name", minWidth: 150, align: "center", },
    { id: "contactNo", label: "Mobile No", minWidth: 50, align: "center", },
    { id: "emailAddress", label: "Email", minWidth: 190, align: "center", },
    { id: "city", label: "City", minWidth: 150, align: "center", },
    { id: "duration", label: "Subscription Duration", minWidth: 150, align: "center", },
    { id: "startdate", label: "Start Date", minWidth: 150, align: "center", },
    { id: "requiredvehicle", label: "Required Vehicle", minWidth: 150, align: "center", },
  ];

  const rows =
    tableData &&
    tableData.map((item) =>
      createData(
        item?.id || "-",
        item?.customerName || "-",
        item?.customerMobile || "-",
        item?.customerEmail || "-",
        cities[item?.cityId] || "-",
        item?.duration + ' month' || "-",
        formatDateAndTime(item?.startDate) || "-",
        item?.requiredVehicleInfo || "-"
      )
    );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getTableData(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    getTableData(0, newRowsPerPage);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: 4,
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  function formatDateForApi(date) {
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const formattedStartDate = formatDateForApi(selectionRange?.startDate);
  const formattedEndDate = formatDateForApi(selectionRange?.endDate);

  const [passFormatStartDate, setPassFormatStartDate] = useState(null);
  const [paasFroendData, setPassFormatEndDate] = useState(null);

  useEffect(() => {
    if (formattedStartDate && formattedEndDate) {
      setPassFormatStartDate(formattedStartDate);
      setPassFormatEndDate(formattedEndDate);
    }
  }, [formattedStartDate, formattedEndDate]);

  const handleProceed = async () => {
    let query = `startDate=${formattedStartDate}&endDate=${formattedEndDate}`;

    if (city && hub) {
      query += `&cityId=${city}&hubId=${hub}`;
    }

    if (executiveId) {
      query += `&createdBy=${executiveId?.id}`;
    }

    if (statusType) {
      query += `&pettyCashStatus=${statusType}`;
    }

    if (vehicleId) {
      query += `&vehicleId=${vehicleId?.id}`;
    }

    if (categoryId) {
      query += `&cashFor=${categoryId}`;
    }

    try {
      const response = await fetch(
        `${apiUrl}/api/petty-cash/reports?${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        const fileUrl = data?.entities?.Location;
        window.open(fileUrl, "_blank");
        try {
          const response = await fetch(fileUrl, {
            method: "GET",
          });

          if (!response.ok) {
            throw new Error("Failed to fetch file");
          }

          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = "pettyCash.csv"; // This is the file name
          document.body.appendChild(a);
          a.click();

          a.remove();
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Download error:", error);
        }
        setOpen(false);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching petty cash report:", error);
    }
  };

  return (
    <>
      {/* {open && (
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              ...style,
              p: 4,
              borderRadius: 2,
              boxShadow: 24,
              backgroundColor: "white",
              minWidth: 300,
              textAlign: "center",
            }}
          >
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              gutterBottom
            >
              Are you sure you want to proceed with this action?
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
              <Button variant="outlined" color="error" onClick={handleClose}>
                No, Cancel
              </Button>

              <Button
                variant="contained"
                color="primary"
                onClick={handleProceed}
              >
                Yes, Proceed
              </Button>
            </Box>
          </Box>
        </Modal>
      )} */}
      <div className="max-w-screen h-full backdrop-blur-sm sm:px-6 md:px-0">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
          <div className="flex items-center gap-4 mt-6">
            <img className="w-20 h-20 rounded-full" src={user} alt="User" />
            <h1 className="text-2xl font-bold">
              Welcome back, {profile?.name}!
            </h1>
          </div>
        </div>

        {/* <div>
            <div className="border rounded-md">
              <DaterangePicker
                selectionRange={selectionRange}
                setSelectionRange={setSelectionRange}
                style={() => {}}
              />
            </div>
          </div> */}

        {/* <div className="mt-6">
            <div className="">
              <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 items-start sm:items-end">
                <FormControl fullWidth size="small">
                  <InputLabel id="city-select-label">City</InputLabel>
                  <Select
                    labelId="city-select-label"
                    id="city-select"
                    value={city}
                    label="City"
                    onChange={handleCityChange}
                  >
                    {cities &&
                      Object.entries(cities).map(([key, value]) => (
                        <MenuItem key={key} value={key}>
                          {value}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth size="small">
                  <InputLabel id="hub-select-label">Hub</InputLabel>
                  <Select
                    labelId="hub-select-label"
                    id="hub-select"
                    value={hub}
                    label="Hub"
                    onChange={handleHubChange}
                  >
                    {hubs?.length ? (
                      hubs.map((item, index) => (
                        <MenuItem key={index} value={item?.id}>
                          {item?.hubName}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="">
                        <em>Select City First</em>
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
          
                <FormControl fullWidth size="small">
                  <InputLabel id="status-select-label">Status</InputLabel>
                  <Select
                    labelId="status-select-label"
                    id="status-select"
                    value={statusType}
                    label="Status"
                    onChange={handleStatusChange}
                  >
                    {Object.entries(pettyCashStatusTypes)?.length ? (
                      Object.entries(pettyCashStatusTypes).map(
                        ([key, value]) => (
                          <MenuItem key={key} value={key}>
                            {value}
                          </MenuItem>
                        )
                      )
                    ) : (
                      <MenuItem value="">
                        <em>Select City First</em>
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
        
                <FormControl fullWidth size="small">
                  <InputLabel id="category-select-label">Category</InputLabel>
                  <Select
                    labelId="status-select-label"
                    id="category-select"
                    value={categoryId}
                    label="category"
                    onChange={handleCategoryChange}
                  >
                    {Object.entries(pettyCashCategoryType)?.length ? (
                      Object.entries(pettyCashCategoryType).map(
                        ([key, value]) => (
                          <MenuItem key={key} value={key}>
                            {value}
                          </MenuItem>
                        )
                      )
                    ) : (
                      <MenuItem value="">
                        <em>Loading...</em>
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
               
                <div className="min-w-[250px] mt-4">
                  <Autocomplete
                    fullWidth
                    freeSolo
                    options={userList} // Add your options here, e.g., ["ID001", "ID002"]
                    getOptionLabel={(option) => {
                      if (option && typeof option === "object") {
                        const name = option.name || "";
                        const id = option.id || "";
                        const email = option?.email;
                        return `${name} - ${email} - ${id}`.trim();
                      }
                      return "";
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Search Executive Id"
                        InputLabelProps={{ shrink: true }}
                        autoComplete="off"
                        // className="h-10"
                      />
                    )}
                    onChange={(event, newValue) => {
                      setExecutiveId(newValue);
                    }}
                  />
                </div>

                <div className="min-w-[250px] mt-4">
                  <Autocomplete
                    fullWidth
                    freeSolo
                    options={vehicleListings} // Add your options here, e.g., ["ID001", "ID002"]
                    getOptionLabel={(option) => {
                      if (option && typeof option === "object") {
                        const name = option.name || "";
                        const id = option.id || "";
                        const licensePlate = option.licensePlate;
                        return `${name} - ${licensePlate} - ${id}`.trim();
                      }
                      return "";
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Search Vehicle No"
                        InputLabelProps={{ shrink: true }}
                        autoComplete="off"
                        // className="h-10"
                      />
                    )}
                    onChange={(event, newValue) => {
                      setVehicleId(newValue);
                    }}
                  />
                </div>
              </div>
            </div>
          </div> */}

        {/* <div className="w-full sm:w-auto flex justify-end sm:ml-auto gap-4 mt-16 sm:mt-0">
            <button
              onClick={() => {
                setPage(0);
                getTableData(0);
              }}
              className="bg-blue-600 text-white px-6 py-2 rounded-full shadow-md hover:bg-blue-700 transition"
            >
              Search
            </button>
            <button
              onClick={() => {
                setCity(null);
                setHub(null);
                setSelectionRange({
                  startDate: oneMonthAgo,
                  endDate: today,
                  key: "selection",
                });
              }}
              className="bg-red-400 text-white px-6 py-2 rounded-full shadow-md hover:bg-gray-500 transition"
            >
              Reset
            </button>
          </div> */}

        {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6 mt-8">

            <div className="w-48 sm:w-48 bg-white rounded-lg shadow-lg border-2 text-center p-4 mb-6 text-[#10B981]">
              <h1 className="font-extrabold text-xl">{stats?.verifiedCash}</h1>
              <h5 className="font-bold mt-2">Verified</h5>
            </div>
            <div className="w-48 sm:w-48 bg-white rounded-lg shadow-lg border-2 text-center p-4 mb-6 text-[#105981]">
              <h1 className="font-extrabold text-xl">{stats?.cashCompleted}</h1>
              <h5 className="font-bold mt-2">Cash Completed</h5>
            </div>
            <div className="w-48 sm:w-48 bg-white rounded-lg shadow-lg border-2 text-center p-4 mb-6 text-[#EF4444]">
              <h1 className="font-extrabold text-xl">
                {stats?.deliveryExpenses}
              </h1>
              <h5 className="font-bold mt-2">Delivery Expenses</h5>
            </div>
            <div className="w-48 sm:w-48 bg-white rounded-lg shadow-lg border-2 text-center p-4 mb-6 text-[#3B82F6]">
              <h1 className="font-extrabold text-xl">{stats?.fuelCharges}</h1>
              <h5 className="font-bold mt-2">Fuel Charges</h5>
            </div>
            <div className="w-48 sm:w-48 bg-white rounded-lg shadow-lg border-2 text-center p-4 mb-6 text-[#F59E0B]">
              <h1 className="font-extrabold text-xl">{stats?.officeExpense}</h1>
              <h5 className="font-bold mt-2">Office Expense</h5>
            </div>
            <div className="w-48 sm:w-48 bg-white rounded-lg shadow-lg border-2 text-center p-4 mb-6 text-[#8B5CF6]">
              <h1 className="font-extrabold text-xl">
                {stats?.vehicleExpenses}
              </h1>
              <h5 className="font-bold mt-2">Vehicle Expenses</h5>
            </div>
            <div className="w-48 sm:w-48 bg-white rounded-lg shadow-lg border-2 text-center p-4 mb-6 text-[#b44df0]">
              <h1 className="font-extrabold text-xl">{stats?.totalCount}</h1>
              <h5 className="font-bold mt-2">Total Count</h5>
            </div>
          </div> */}

        <div className="mt-6 flex justify-between">
          <h1 className="font-semibold text-xl sm:text-xl">
            Customer Subscription List
          </h1>

          {/* <div title="Download Petty Cash Report" className="flex gap-3">
            <button
              onClick={handleOpen}
              className="flex shadow-xl items-center gap-2 bg-white text-teal-900 font-semibold py-2 px-4 rounded-full"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 4v12"
                ></path>
              </svg>
            </button>
          </div> */}
        </div>

        <div className="overflow-y-hidden hide-scrollbar w-full">
          <Paper
            sx={{
              width: "100%",
              overflow: "hidden",
              marginTop: 4,
              boxShadow: 6,
              borderRadius: 2,
              paddingBottom: 4,
            }}
          >
            <TableContainer
              sx={{
                overflowX: { xs: "auto", sm: "auto" },
                overflowY: "hidden", // disable Y scroll
              }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        // sx={{
                        //   border: "1px solid #e0e0e0", // light gray border
                        //   backgroundColor: "#f5f5f5", // optional: subtle header background
                        // }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={columns.length} align="center">
                        <div className="flex flex-col items-center h-40 justify-center">
                          <BlinkBlur
                            color={["#cd8032", "#32cd32", "#327fcd", "#cd32cd"]}
                          />
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : rows.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={columns.length} align="center">
                        <div className="text-center mx-auto">
                          <h1 className="mt-10 text-lg font-bold">
                            No Data Found
                          </h1>
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : (
                    rows.map((row) => (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.code}
                      >
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              className="cursor-pointer"
                              key={column.id}
                              align={column.align}
                            >
                              {column.id === "action" ? (
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={() => handleViewClick(row)}
                                >
                                  View
                                </Button>
                              ) : column.format && typeof value === "number" ? (
                                column.format(value)
                              ) : (
                                value
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[20, 30, 40]} // disables the dropdown
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage} // fixed
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={(event) => {
                handleChangeRowsPerPage(event);
              }} // no-op
            />
          </Paper>
        </div>
      </div>
    </>
  );
};

export default Customersubscriptiondashboard;
